module.exports = __webpack_public_path__ + "static/media/cosmos-logo-white.9cf29cf0.png";